import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

import { request } from '../../../api';
import cancelPieceForm from '../cancel_piece_form';

const VtrgCustomHtmlForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    body: data && data.body ? data.body : ''
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (localData, e) => {
    setDisableBtns(true);
    if (ordn) {
      setActionLoading(ordn);
    }

    // TODO костыль
    //console.log(e.action);
    //console.log(values);
    //console.log(localData);
    Object.keys(localData)
      .filter(key => key in values)
      .forEach(key => (localData[key] = values[key]));
    //
    
    axios
      .post(`${request}/vitrage/pieces/${slot ? slot : 'new'}`, localData)
      .then(response => {
        if (response.statusText === 'OK') {
          setSuccessMsg('Изменения успешно внесены');
          if (!slot && response.data.content) {
            getPieceForm(null);
            afterUpdateVtrgPiece(response.data.content);
          } else {
            afterUpdateVtrgPiece(localData);
          }
        } else {
          setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
        }
      })
      .catch(error => {
        console.log(error);
        setErrorMsg('Произошли ошибки, пожалуйста попробуйте позже.');
      })
      .finally(() => {
        setDisableBtns(false);
        setTimeout(() => {
          setSuccessMsg(null);
          setErrorMsg(null);
          updatePiece(null);
          setActionLoading(null);
        }, 500);
      });
  };

  const onError = (errors, e) => {
    console.log(errors);
    setErrorMsg('Произошла ошибка');
  };

  return (
    <div className="vtrg-edit-body">
      <h3>Блок HTMl:</h3>

      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate="novalidate"
        className="vitrage_pieces_vtrg_custom_html"
        encType="multipart/form-data"
        action={`${request}/vitrage/pieces/${slot ? slot : 'new'}}`}
        accept-charset="UTF-8"
        data-remote="true"
        method="post"
      >
        
        <fieldset className="inputs">
          <label>Код*</label>
        </fieldset>
        <textarea
          className="vtrg_long_textarea"
          rows="6"
          id="vitrage_pieces_vtrg_custom_html_body"
          required
          name="vitrage_pieces_vtrg_custom_html[body]"
          {...register('body', { value: values.body })}
          onChange={e => {
            setValues(values => {
                values.body = e.target.value;
                return values;
            });
          }}
        >
          {data && data.body ? data.body : ''}
        </textarea>

        <input
          type="hidden"
          name="kind"
          value={pieceType}
          {...register('kind', { value: pieceType })}
        />
        <input
          type="hidden"
          name="owner_type"
          value={instanceType}
          {...register('owner_type', { value: instanceType })}
        />
        <input
          type="hidden"
          name="owner_id"
          value={instanceId}
          {...register('owner_id', { value: instanceId })}
        />

        {successMsg && <p className="success-hint">{successMsg}</p>}
        {errorMsg && <p className="error-hint">{errorMsg}</p>}
        {disableBtns && <span className="loading-hint"> Подождите ... </span>}

        <fieldset className={disableBtns ? 'actions_disable' : 'actions'}>
          <input type="submit" />
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      </form>
    </div>
  );
};

export default VtrgCustomHtmlForm;
